import * as React from "react";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import { Button, Modal } from "@mui/material";
import {
  ButtonsContainer,
  FieldContainer,
  FormContainer,
  Fragment,
  PopupBody,
  PopupButton,
  PopupHeader,
  SectionTitle,
} from "./AddNotePopup.styled";
import InputField from "../../../components/formFields/InputField";
import { Form, Formik } from "formik";
import { useAddMemberHistoryNoteMutation } from "../../../services/InsuranceService";
import useFetchWithMsal from "../../../utils/useFetchWithMsal";

export const AddNotePopup = ({ open, onClose, memberKey, handleAddMemberHistoryNote }) => {

  const handleSubmit = (values) => {
    const body = {
      memberKey: memberKey,
      note: values.note,
    };
    handleAddMemberHistoryNote(body);
    onClose()
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <PopupBody>
        <Fragment>
          <PopupHeader>
            <Box>
              <SectionTitle>Add Note</SectionTitle>
            </Box>
            <PopupButton aria-label="close" onClick={onClose}>
              <CloseIcon />
            </PopupButton>
          </PopupHeader>
          <Box
            sx={{
              p: 1,
            }}
          >
            <Formik
              onSubmit={handleSubmit}
              initialValues={{ note: '' }}
            >
              {({ values, handleChange }) => (
                <Form>
                  <FormContainer>
                    <FieldContainer sx={{width: "500px"}}>
                      <InputField
                        name="note"
                        label="Note"
                        fullWidth
                        multiline
                        type="textarea"
                        height="150px"
                        width="500px"
                      />
                    </FieldContainer>
                      <ButtonsContainer>
                        <Button variant="outlined" type="submit">
                          Add Note
                        </Button>
                        <Button variant="outlined" type="reset" onClick={onClose}>
                          Cancel
                        </Button>
                      </ButtonsContainer>
                  </FormContainer>
                </Form>
              )}
            </Formik>
          </Box>
        </Fragment>
      </PopupBody>
    </Modal>
  );
};
